import { render } from "./LocationDetails.vue?vue&type=template&id=49bcb42e&scoped=true&ts=true"
import script from "./LocationDetails.vue?vue&type=script&lang=ts"
export * from "./LocationDetails.vue?vue&type=script&lang=ts"

import "./LocationDetails.vue?vue&type=style&index=0&id=49bcb42e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49bcb42e"]])

export default __exports__